<style scoped>
@import '../../css/base/variables.css';
.input-add-item {
  float: left;
}
.input-add-item .add-btn {
  border: 1px solid #ccc;
  margin: 5px;
  background: var(--white-color);
}
.input-add-item .btn .fa-plus {
  margin-right: 5px;
}
.input-item {
  float: left;
  margin: 5px 0;
  position: relative;
}
.input-item .fa-close {
  position: absolute;
  right: 10px;
  top: 9px;
  color: #adbdcc;
}
.item {
  overflow: hidden;
  margin-top: 15px;
}
.item .label {
  float: left;
  margin: 5px 0;
  text-align: right;
  width: 80px;
}
.item .label-inline {
  float: left;
  margin: 10px 0;
  padding-left: 20px;
}
.item .control {
  margin-left: 80px;
}
.item .province {
  display: inline-block;
  color: #596980;
  width: 60px;
  height: 28px;
  margin: 5px;
  border: 1px solid #dadfe6;
  cursor: pointer;
  text-align: center;
  line-height: 28px;
}
.item .input-wrap {
  margin-left: 5px;
  margin-right: 0;
}
.input-add-item .btn-primary {
  margin-left: 4px;
}
.item .province.active {
  color: #28bc4e;
  border-color: #28bc4e;
}
.item .gray {
  background: #ccc;
  color: #fff;
}
.gray {
  color: #ccc;
}
.item .white {
  color: #fff;
}
</style>
<template lang="pug">
.report 
  PageTitle(
    pagetitle="搜索分析",
    tip="帮助您了解互联网用户对搜索词的关注程度及变化趋势；找到与核心搜索词相关性高的热门搜索词，优化搜索推广策略，提升广告效果")
  div.time
    TimeSpan(filters="7a" @change="onTimespanChange")

  .zone
    TableTitle(icon="fa fa-signal" title="趋势图")

    LineChart(
      :legend="legend",
      :xAxis="chartXAxis",
      :series="chartSeries")
  .zone
    TableTitle(icon="fa fa-list", :title="tableTabTitle")
    div.nav-tabs
      TabContent(
        title="主维度：",
        :tablist="tablist",
        :update="updateTab")
        DownloadBtn(
          slot="extentTab",
          :reportApi="reportApi",
          :params="query",
          :pagetitle="tableTabTitle",
          subtitle="",
          v-if="total > 0")
        div(slot="keyword") 
          p.plan-nav
            | 选择二级维度：
            v-radio-group(
              v-model="sdim",
              name="secondaryDim",
              @change.native="sdimChange",
              :options="sdimOptions")
          div.item
            span.label-inline 搜索词：
            .control
              .input-item(v-for="(item,index) in keywordList")
                v-input(
                  v-model="item.value",
                  placeholder="请输入搜索词（最多10个）",
                  @input.native="pushKeyword($event, item)" )
                i.fa.fa-close(
                  @click="removeKeyword(index)",
                  v-show="index != 0")
              .input-add-item
                button.btn.add-btn(
                  :disabled="keywordList.length == 10",
                  @click.prevent="addKeyword")
                  i.fa.fa-plus 
                  | 添加搜索词
                button.btn.btn-primary.btn-small(@click.prevent="searchKeyword") 确定 
        div(slot="province") 
          div.item
            .label 添加搜索词：
            .control
              v-input(v-model="provinceKeyword" placeholder="请输入一个关键词")
          div.item
            .label-inline 选择地域：
            .control
              ul
                li.province(v-for="(province,index) in provinces",
                    :class="{active: province.active}",
                    :key="province.id"
                    @click="selectProvince(province, index)"
                  ) {{province.value}}
                li.province.btn-primary.white.btn-small(
                  @click="searchKeyword",
                  :class="{gray: provinceSearchDisabled}"
                ) 确定
          
        div(slot="common") 
          p.tabAction
            button.btn.btn-primary(
              :disabled="fetchLineChartabled",
              @click="fetchLineChartData"
            ) 绘制选定行

    complex-table(
      :classname="'bluethead opt-table'",
      :columns="columns",
      :list="tableDataList",
      :sum="{}",
      :checkbox="hasCheckBox",
      :checkbox_length="checkboxLength")
      v-tooltip(
        slot="snum",
        :tip="'对各关键词在360搜索中搜索频次数据进行加权计算，反映某关键词的搜索规模'",
        pos="right")
        i.fa.fa-question-circle(style="margin-left: 5px;")

    v-pagination(
      :total="total",
      :pn="pg",
      :ps="ps",
      v-if="total > ps",
      @updatepage="getTableData")
</template>
<script>
  import Vue from 'vue'
  import Store from '../../store/store.js'
  import Table from '../../component/complex-table.vue'
  import Mixin from '../mixin.js'
  import { PROVINCES_OF_DIANJING } from './constants.js'
  export default {
    store: Store,
    mixins: [Mixin],
    components: {
      'complex-table': Table
    },
    data() {
      return {
        //用于画图
        twoIndiceSelectabled: true,
        hasCheckBox: true,
        checkboxLength: 3,
        chartResList: [],
        legend: [],
        chartXAxis: [],
        chartSeries: [],
        total: 0,
        pg: 1,
        ps: 10,
        sdim: 'null',
        currentTab: 'keyword',
        tablist: [
          {
            id: 'keyword',
            name: '搜索词',
            reportTableApi:'/api/keyword/keywordindex',
            reportLineChartApi: '/api/keyword/keywordindex'
          },
          {
            id: 'province',
            name: '地域',
            reportTableApi:'/api/keyword/keywordindex',
            reportLineChartApi: '/api/keyword/keywordindex'
          }
        ],
        customIndice: "snum",
        tableDataList: [],
        provincelist: [],
        provinces: [],
        keywordList: [{value: ''}],
        provinceKeyword: '',
        sdimOptions: []
      }
    },
   computed: {
      provinceSearchDisabled() {
        return _.isEmpty(this.provinceKeyword) || this.provincelist.length == 0
      },
      keyword() {
        return this.keywordList.map(s => s.value).join(",")
      },
      tableTabTitle() {
        return _.find(this.tablist, {id: this.currentTab}).name + '报表'
      },
      columns() {
        let columns = [
          {
            title: '搜索词',
            key: 'name'
          },{
            title: '搜索指数',
            key: 'snum',
            render: this.columnRender
          },{
            title: '环比',
            class: 'right',
            key: 'huanbi'
          }
        ]
        columns[0].title = _.find(this.tablist, {id: this.currentTab}).name
        return columns
      },
      domainId() {
        return this.$store.state.domainId
      },
      uiError() {
        return this.$store.state.uiError
      },
      fetchLineChartabled() {
        return this.$store.state.tableCheckList.length == 0 || !this.$store.state.drawChartabled
      },
      query() {
        let query = {
          cycle: this.$store.state.start == this.$store.state.end ? 'hour' : 'day',
          domainId: this.domainId,
          start: this.$store.state.start,
          end: this.$store.state.end,
          keyword: this.currentTab == 'keyword' ? this.keyword : this.provinceKeyword.trim(),
          pvtype: 0,
          mdim: this.currentTab,
          timespan: new Date().getTime(),
        }
        if(this.sdim != "null"){
          query = _.assignIn({
            sdim: this.sdim
          }, query)
        }
        if(this.currentTab == 'province' && this.provincelist.length > 0){
          this.$set(query, 'province', this.provincelist.join(","))
        }
        return query
      },
      reportApi() {
        return _.find(this.tablist, {id: this.currentTab}).reportTableApi
      }
    },
    mounted() {
      this.getProvinces()
    },
    watch: {
      domainId() {
        this.clearKeyword()
        this.getTableData()
      },
      uiError() {
        this.$Modal.warn(this.uiError.errMsg)
      }
    },
    methods: {
      getProvinces(){
        let list = []
        _.map(PROVINCES_OF_DIANJING, (item, index) => {
          list.push({
            id: index,
            value: item,
            active: false
          })
        })
        list.push({
          id: 1001,
          value: '其他',
          active: false
        })
        this.provinces = list
      },
      selectProvince(province, index) {
        if(province.id == 0){
          if(!province.active) { //全国处于未选中状态
            this.provincelist = []
            this.provincelist.push(province.id)

            this.provinces.forEach( p => this.$set(p, 'active', true) )
          } else {                //全国处于选中状态
            this.provincelist = []
            this.provinces.forEach( p => this.$set(p, 'active', false) )
          }
        }else{ //如果选择的是具体的省份
          if(!province.active) {
            this.$set(province, 'active', true)
            if( this.provinces.slice(1).every( p => p.active ) ) { //如果选择了所有的省份
              this.$set(this.provinces[0], 'active', true)
              this.provincelist = []
              this.provincelist.push(0)
            } else {
              this.provincelist.push(province.id)
            }
          } else {
            if(this.provincelist.some(p => p === 0)){ //全国被选中时
              this.$set(this.provinces[0], 'active', false)
              this.$set(province, 'active', false)
              this.provincelist = this.provinces.filter( p => p.active ).map( p => p.id )
            } else {
              this.$set(province, 'active', false)
              this.provincelist = this.provincelist.filter( p => p !== province.id )
            }
          }
        }
      },
      pushKeyword(e, item) {
        this.$set(item, 'value', e.target.value)
      },
      addKeyword() {
        if(this.keywordList.length == 10) return
        this.keywordList.push({value: ''})
      },
      removeKeyword(index) {
        this.keywordList.splice(index, 1)
      },
      searchKeyword() {
        if(this.currentTab == 'keyword' && !this.keywordList.some(w => !!w.value.trim())){
          this.keywordList = [{value: ''}]
          return this.$Modal.warn("请至少指定一个搜索词")
        }
        if(this.currentTab == 'keyword'){
          this.keywordList = this.keywordList.filter(w => w.value.trim()).map(w => {w.value = w.value.trim(); return w})
        }
        if(this.currentTab == 'province' && this.provinceSearchDisabled){
          return
        }
        this.getTableData()
      },
      onTimespanChange({start, end}) {
        this.compareStart = start
        this.compareEnd = end
        if((new Date(end) - new Date(start)) > 365*24*3600*1000){
          return this.$Modal.warn(`您选择时间段超过了一年`)
        }
        this.getTableData()
      },
      updateTab(tab) {
        if(this.currentTab == tab) return
        this.currentTab = tab
        this.sdim = "null"
        this.keywordList = [{value: ''}]
        this.provinceKeyword = ""
        this.getProvinces()
        this.provincelist = []
        this.getTableData()
        this.resetData()
      },
      //清除报表和绘图数据
      resetData() {
        this.tableDataList = []
        //清空画图数据
        this.legend = [] 
        this.chartXAxis = []
        this.chartSeries = []
      },
      getTableData(pn = 1) {
        this.pg = pn
        if(!this.domainId) return
        this.total = 0
        this.$store.dispatch("SET_TABLE_LOADING", true)
        this.$store.dispatch("SET_TABLE_CHECKLIST", [])
        let params = _.cloneDeep(this.query)
        params.pg = this.pg
        params.ps = this.ps
        let reportPromise = this.$http.get(_.find(this.tablist, {id: this.currentTab}).reportTableApi, {params:params})
        this.$store.dispatch("VUE_HTTP", [reportPromise])
          .then((res) => {
              if(res){
                this.$store.dispatch("SET_TABLE_LOADING", false)
                this.sdimOptions = this.getSdimOptionList(res.ext_info)
                let reportlist = this.addItemChecked(res.list)
                this.tableDataList = reportlist
                this.total = res.total
                if(reportlist.length > 0){
                  let checklist = _.concat([], reportlist[0])
                  this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
                  this.fetchLineChartData()
                }else{
                  this.resetData()
                }

              }
          })
      }
    }
  }

</script>



// WEBPACK FOOTER //
// search.vue?68dd38d7